export interface locker {
  id: number;
  serial: number;
  isActive: string;
  kiosk: {
    address: string;
    description: string;
    lat: string;
    lon: string;
    id: number;
  };
  lockerType: {
    id: number;
    description: string;
    length: number;
    width: number;
    height: number;
    weight: number;
  };
  orders: [
    {
      orderNumber: string;
      lockerAmount: number;
      taxAmount: number;
      finalAmount: number;
      cycleState: string;
      cancleDescription: string;
      locker: string;
      id: number;
      orderComment: string;
      registerDate: string;
      registerTime: string;
      expireDate: string;
      startDate: string;
      startTime: string;
      endDate: string;
      endTime: string;
      paymentType: string;
      cancleReason: string;
      histories: [
        {
          id: number;
          orderState: string;
          date: string;
          time: string;
          username: string;
        }
      ];
      passwords: [
        {
          id: number;
          paid: string;
          needPayment: string;
          amount: number;
          content: string;
          type: string;
          expireDate: string;
          expireTime: string;
          order: string;
        }
      ];
    }
  ];
}

export interface userAccessibleLKiosk {
  count: number;
  status: number;
  bunches: [
    {
      id: number;
      isActive: string;
      isRental: string;
      description: string;
      address: string;
      addressEn: string;
      lat: number;
      lon: number;
      kioskType: {
        id: string;
        description: string;
        lockerTypes: [
          {
            id: number;
            description: string;
            length: number;
            width: number;
            height: number;
            weight: number;
          }
        ];
      };
      lockers: locker[];
      shifts: [
        {
          id: string;
          startTime: string;
          endTime: string;
        }
      ];
    }
  ];
}

const kioskColumns = [
  {
    title: 'آدرس',
    key: 'address',
    dataIndex: 'address',
  },
  {
    title: 'توضیحات',
    key: 'description',
    dataIndex: 'description',
  },

  {
    title: 'عرض جغرافیایی',
    key: 'lat',
    dataIndex: 'lat',
    render: (_text: any, record: Record<string, any>) => {
      return record.lat;
    },
  },

  {
    title: 'طول جغرافیایی',
    key: 'lon',
    dataIndex: 'lon',
    render: (_text: any, record: Record<string, any>) => {
      return record.lon;
    },
  },
];

export interface orderServices {
  title: string;
  layerId: number;
  layerTitle: string;
  serviceTypeId: number;
  serviceTypeTitle: string;
  serviceGroupId: number;
  serviceGroupTitle: string;
  isActive: boolean;
  creatorId: number;
  modifierId: number;
  creationDate: string;
  modificationDate: string;
  creationTime: string;
  modificationTime: string;
  creator: string;
  modifier: string;
  id: number;
}

export interface orderReservedByLocker {
  orderNumber: string;
  lockerAmount: number;
  taxAmount: number;
  finalAmount: number;
  cycleState: string;
  cancleDescription: string;
  locker: {
    id: number;
    serial: number;
    isActive: string;
    kiosk: {
      id: number;
      isActive: string;
      isRental: string;
      description: string;
      address: string;
      addressEn: string;
      lat: string;
      lon: string;
      kioskType: {
        id: string;
        description: string;
        lockerTypes: [
          {
            id: number;
            description: string;
            length: number;
            width: number;
            height: number;
            weight: number;
          }
        ];
      };
      lockers: string[];
      shifts: [
        {
          id: string;
          startTime: string;
          endTime: string;
        }
      ];
    };
    lockerType: {
      id: number;
      description: string;
      length: number;
      width: number;
      height: number;
      weight: number;
    };
    orders: string[];
  };
  id: number;
  orderComment: string;
  registerDate: string;
  registerTime: string;
  expireDate: string;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  paymentType: string;
  cancleReason: string;
  histories: [
    {
      id: number;
      orderState: string;
      date: string;
      time: string;
      username: string;
    }
  ];
  passwords: [
    {
      id: number;
      paid: string;
      needPayment: string;
      amount: number;
      content: string;
      type: string;
      expireDate: string;
      expireTime: string;
      order: string;
    }
  ];
}

export interface inqueryLocker {
  id: number;
  serial: number;
  isActive: string;
  kiosk: {
    id: number;
    isActive: string;
    isRental: string;
    description: string;
    address: string;
    addressEn: string;
    lat: string;
    lon: string;
    kioskType: {
      id: string;
      description: string;
      lockerTypes: [
        {
          id: number;
          description: string;
          length: number;
          width: number;
          height: number;
          weight: number;
        }
      ];
    };
    city: {
      id: number;
      description: string;
      type: string;
      lat: string;
      lon: string;
      parentId: string;
      isActive: string;
    };
    lockers: [
      {
        id: number;
        serial: number;
        isActive: string;
        kiosk: string;
        lockerType: {
          id: number;
          description: string;
          length: number;
          width: number;
          height: number;
          weight: number;
        };
        orders: [
          {
            orderNumber: string;
            lockerAmount: number;
            taxAmount: number;
            finalAmount: number;
            cycleState: string;
            cancleDescription: string;
            locker: string;
            id: number;
            orderComment: string;
            registerDate: string;
            registerTime: string;
            expireDate: string;
            startDate: string;
            startTime: string;
            endDate: string;
            endTime: string;
            paymentType: string;
            cancleReason: string;
            histories: [
              {
                id: number;
                orderState: string;
                date: string;
                time: string;
                username: string;
              }
            ];
            passwords: [
              {
                id: number;
                paid: string;
                needPayment: string;
                amount: number;
                content: string;
                type: string;
                expireDate: string;
                expireTime: string;
                order: string;
              }
            ];
          }
        ];
      }
    ];
    shifts: [
      {
        id: string;
        startTime: string;
        endTime: string;
      }
    ];
  };
  lockerType: {
    id: number;
    description: string;
    length: number;
    width: number;
    height: number;
    weight: number;
  };
}

export interface inqueryKiosk {
  count: number;
  status: number;
  message: string;
  lockers: inqueryLocker[];
}

export interface pudoBranchAddress {
  cityId: number;
  cityETipaxId: number;
  jetCityId: string;
  cityTitle: string;
  provinceId: number;
  provinceTitle: string;
  fullAddress: string;
  postalCode: string;
  latitude: number;
  longitude: number;
  plaque: number;
  unit: number;
  floor: number;
  description: string;
  exclusiveCode: string;
  start: string;
  end: string;
  linkAddressId: number;
  isActive: boolean;
  creatorId: number;
  modifierId: number;
  creationDate: string;
  modificationDate: string;
  creationTime: string;
  modificationTime: string;
  creator: string;
  modifier: string;
  id: number;
}

export interface pudoBranch {
  title: string;
  latinTitle: string;
  jetId: string;
  cityId: number;
  cityTitle: string;
  provinceId: number;
  provinceTitle: string;
  branchCode: string;
  address: pudoBranchAddress;
  isActive: boolean;
  creatorId: number;
  modifierId: number;
  creationDate: string;
  modificationDate: string;
  creationTime: string;
  modificationTime: string;
  creator: string;
  modifier: string;
  id: number;
}

const KioskListTitle = 'لیست کیوسک ها';
const KioskListOnMapTitle = 'لیست کیوسک‌/‌پودو ها برروی نقشه';
const lockerModel = { kioskColumns, KioskListTitle, KioskListOnMapTitle };

export default lockerModel;
